import React from 'react'

export type ToastKind = 'success' | 'error' | 'info'

export interface ToastProps {
  kind?: ToastKind
  title: React.ReactNode
  detail?: React.ReactNode
  onDismiss?: () => void
  style?: React.CSSProperties
}

/**
 * Deliberately the ONE opaque surface in a glass app.
 *
 * A toast is a transient message that lands on top of whatever you were reading
 * — usually a dialog. Frosting it would let the form underneath bleed through
 * exactly when the text matters most, so this is a solid slate panel with a
 * status dot: red error, green success, blue info. Placement (top centre, above
 * the Dialog's z-index) is owned by ToastProvider in src/lib/toast.tsx.
 */
export function Toast({ kind = 'success', title, detail, onDismiss, style }: ToastProps) {
  const dot = { success: '#22c55e', error: '#ef4444', info: '#60a5fa' }[kind]

  return (
    <div role="status" aria-live="polite" className="lm-toast" style={style}>
      <span className="lm-toast-dot" style={{ background: dot }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="lm-toast-title">{title}</div>
        {detail && <div className="lm-toast-detail">{detail}</div>}
      </div>
      {onDismiss && (
        <button aria-label="Dismiss" className="lm-toast-x" onClick={onDismiss}>
          ✕
        </button>
      )}
    </div>
  )
}
